// Helpers para el sistema de permisos por sección
export const can = (user, seccion, nivel = "ver") => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const p = user.permisos || {};
  const n = p[seccion] || "ninguno";
  if (nivel === "ver") return n === "ver" || n === "editar";
  if (nivel === "editar") return n === "editar";
  return false;
};

export const canEdit = (user, seccion) => can(user, seccion, "editar");
export const canView = (user, seccion) => can(user, seccion, "ver");
